import { Descriptions, Modal } from "antd";
import styled from "styled-components";

export const StyledTransactionDetailModal = styled(Modal)`
  .ant-descriptions-item-label {
    width: 150px;
  }
`;

export const StyledTransactionDetailDescriptions = styled(Descriptions)`
  th,
  td {
    padding: 5px 10px !important;
  }
`;
